import { atom } from 'recoil';
import { UploadError } from 'types/api';

export const showUploadErrorState = atom<boolean>({
  key: 'ShowUploadError',
  default: false,
});

export const uploadPendingState = atom<boolean>({
  key: 'UploadPending',
  default: false,
});

export const uploadErrorsState = atom<UploadError[]>({
  key: 'UploadError',
  default: [],
});
